import { cva, type VariantProps } from "class-variance-authority";
import clsx from "clsx";
import type { PropsWithChildren } from "react";
import { type IconType, icon } from "../icons";
import { useTranslation } from "../localization";
import type { ClassNameProps } from "../types";

/** Props Interface */
interface BlankSlateInlineProps
	extends ClassNameProps,
		VariantProps<typeof blankSlateInlineClasses>,
		PropsWithChildren {
	onClick?: () => void;
	label?: string;
	Icon?: IconType;
}

export function BlankSlateInline({
	onClick,
	label: _label,
	className,
	Icon,
	variant,
	children,
}: BlankSlateInlineProps) {
	/** Hooks */
	const { t } = useTranslation();

	const classes = blankSlateInlineClasses({ variant });

	/** Computed */
	const label = _label === null ? null : _label || t("general.no_data_available");

	const IconComponent = Icon || icon("Box");

	/** Render */
	return (
		<div className="input-wrapper flex flex-col gap-2 w-full">
			{children && <p className="label">{children}</p>}
			<div className={classes}>
				<div
					className={clsx("h-stack", onClick && "cursor-pointer", className)}
					onClick={onClick}
				>
					<IconComponent />
					<p>{label}</p>
				</div>
			</div>
		</div>
	);
}

const blankSlateInlineClasses = cva([], {
	variants: {
		variant: {
			input: ["input"],
			default: [],
		},
	},
	defaultVariants: {
		variant: "default",
	},
});
